import { Skeleton } from "primereact/skeleton";
import { Card } from "primereact/card";
import { Button } from "primereact/button";

import { themeClasses } from "sj-ui-toolkit/src/atlas/utils";
import { ContentTag } from "sj-ui-toolkit/src/atlas/components";

const UserAssessmentSummarySkeleton = () => {
  return (
    <div className="grid grid-cols-3 gap-4">
      {/* Left Panel Skeleton */}
      <div className="col-span-1 mt-1">
        <div className="flex flex-col gap-6">
          <ContentTag value="assessment" className={themeClasses.bgElevation2} />
          <div className="flex flex-col gap-2">
            <Skeleton width="4rem" height="1rem" className="opacity-60" />
            <Skeleton width="12rem" height="1.5rem" />
          </div>
        </div>
      </div>

      {/* Right Panel Skeleton */}
      <div className="relative col-span-2">
        <Card
          className={`${themeClasses.bgElevation2} atlas-bg-summary -mr-10 rounded-tl-2xl relative flex flex-col min-h-[calc(100vh-5rem)]`}
          style={{ backgroundRepeat: "no-repeat" }}
        >
          <div className="flex-shrink-0">
            {/* Header Skeleton */}
            <div className="flex justify-between items-center mb-8">
              <Skeleton width="20rem" height="2rem" />
              <Button severity="secondary" disabled icon="pi pi-download" label="Download PDF" />
            </div>

            {/* Stats Grid Skeleton */}
            <div className="grid grid-cols-3 gap-6 mb-10">
              <div className="flex flex-col gap-1">
                <Skeleton width="12rem" height="1rem" className="opacity-60" />
                <Skeleton width="6rem" height="2rem" />
                <Skeleton width="8rem" height="0.875rem" className="opacity-60" />
              </div>
              <div className="flex flex-col gap-1">
                <Skeleton width="10rem" height="1rem" className="opacity-60" />
                <Skeleton width="5rem" height="2rem" />
              </div>
              <div className="flex flex-col gap-1">
                <Skeleton width="9rem" height="1rem" className="opacity-60" />
                <Skeleton width="7rem" height="2rem" />
                <Skeleton width="10rem" height="0.875rem" className="opacity-60" />
              </div>
            </div>

            {/* Category Cards Skeleton */}
            <div className="space-y-12 mb-12">
              {Array.from({ length: 3 }, (_, index) => (
                <div key={index} className="rounded-lg p-4">
                  <div className="mb-3">
                    <div className="flex items-center justify-between mb-3">
                      <Skeleton width="10rem" height="1.25rem" />
                      <Skeleton width="1.5rem" height="1.5rem" className="rounded-full" />
                    </div>
                    <Skeleton width="8rem" height="0.5rem" className="rounded-full" />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Questions Section Skeleton */}
          <div className="flex-1 overflow-y-auto">
            <div className="space-y-2">
              {Array.from({ length: 6 }, (_, index) => (
                <div key={index} className="rounded-lg">
                  <div className="p-4 flex items-center justify-between cursor-pointer">
                    <div className="flex items-center gap-3">
                      <Skeleton shape="circle" size="1.5rem" />
                      <Skeleton width="20rem" height="1.25rem" />
                    </div>
                    <Skeleton width="1.5rem" height="1.5rem" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default UserAssessmentSummarySkeleton;
